import * as React from 'react';
import { Countable } from '../../../../types';
import { LimtuMembreModal } from './KhassidaModal';

type AlQuranModalProps = {
  show: boolean;
  onHide: () => void;
  data: Countable[];
};

const SalatouModal = ({ show, onHide, data }: AlQuranModalProps) => {
  const filtred = React.useMemo(() => {
    return data.filter((d) => d.salatou);
  }, [data]);
  return (
    <LimtuMembreModal
      onHide={onHide}
      show={show}
      title="Limu Salaatu Yi"
      item={{
        uid: '',
        count: 0,
        counts: filtred,
        item: { title: 'Limu Salaatu Yi', created_at: 1230000303, uid: '' }
      }}
    />
  );
};

export default SalatouModal;
